import CircleCheck2 from '@assets/icons/circle-check-2.svg'
import { Icon } from './Icon'

export const CircleCheck2Icon = Icon(CircleCheck2)
